module.exports = __webpack_public_path__ + "static/thnkdev-51027c6d368e37dc9d0d161b65da9ae3.png";